// eslint-disable-next-line import/prefer-default-export
export const PRODUCT_CARD = 'js-product-card';
export const PRODUCT_CARD_V3 = 'js-product-card-v3';
export const PRODUCT_SUBSCRIPTION_CONTENT = '.product-and-subscription-content';
export const PRODUCT_CARD_PRICE = '.js-product-card-price';
export const SUBSCRIPTION_PRICE_LABEL = '.js-subscription-price-label';
// This class is used only through admin settings, so you won't find it in liquid
export const VARIANT_TITLE = '.js-variant-title';

export const SUBSCRIPTION_PRICE_VALUE = 'js-subscription-price-value';

export const OTP_PRICE_VALUE = 'js-otp-price-value';

export const SERVING_PRICE_VALUE = 'js-serving-price';

export const OTP_DISCOUNTED_PRICE_VALUE = 'js-otp-price-discounted-value';
